/**
 * Вспомогательные функции модуля «Школы».
 * Здесь разведены три разных «языка», чтобы их не путать:
 *   1) язык ИНТЕРФЕЙСА  — i18n.language ('ru' | 'kz');
 *   2) суффикс полей API — 'ru' | 'kk' (label_ru / label_kk);
 *   3) фильтр по языку ОБУЧЕНИЯ — 'kz' | 'ru' | 'both' | 'none' (данные, не UI).
 */

/**
 * Суффикс двуязычных полей API по языку интерфейса.
 * Внимание: казахский в i18next зарегистрирован как 'kz', а поля API — '..._kk'.
 * Правило (проверено на проекте): всё, что не начинается с 'ru', считаем казахским.
 */
export const apiLang = (i18nLang) =>
  (i18nLang || '').toLowerCase().startsWith('ru') ? 'ru' : 'kk';

/** Значение locale для запроса экспорта (ru/kk — как ждёт бэкенд). */
export const exportLocale = (i18nLang) => apiLang(i18nLang);

/** Достаёт нужный язык из объекта вида {label_ru, label_kk} / {shift_label_ru, ...}. */
export const pickLabel = (obj, i18nLang, prefix = 'label') =>
  obj ? obj[`${prefix}_${apiLang(i18nLang)}`] : '';

/** Локаль для форматирования чисел. */
const numLocale = (i18nLang) => (apiLang(i18nLang) === 'ru' ? 'ru-RU' : 'kk-KZ');

/** Число с разделителями разрядов по локали; «нет данных» → прочерк. */
export const fmtNum = (n, i18nLang) =>
  n == null ? '—' : Number(n).toLocaleString(numLocale(i18nLang));

/** Загруженность: один знак после запятой + «%»; «нет данных» → прочерк. */
export const fmtPct = (n, i18nLang) =>
  n == null
    ? '—'
    : `${Number(n).toLocaleString(numLocale(i18nLang), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}%`;

/** Доля в процентах (целое) для легенд круговых диаграмм. */
export const share = (n, total) => (total ? Math.round((n / total) * 100) : 0);
